import React from "react";

function TableDashboard({ data }) {
  const tableCellStyle = {
    color: "black",
    border: "2px solid black ",

    // textAlign: "center"
  };

  const tableHeaderStyle = {
    border: "2px solid black !important",
    background: "#f2f2f2",

  };

  return (
    <>
      <div className="" style={{ paddingBottom: "70px" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ height: '35px !important' }}>
              {data?.headers.map((header) => (
                <th
                  className={"customTh"}
                  key={header}
                  // style={{ border: "2px solid black !important" }}
                  style={tableHeaderStyle}
                // style={{ background: '#143b64', color: '#FFFFFF', fontWeight: 'bold',border: "2px solid black !important" }}


                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody >
            {data?.data.length > 0 ? (
              data?.data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <td className="abc" key={cellIndex} style={tableCellStyle}>
                      {cell}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                {data?.headers.map(() => {
                  return (
                    <td style={tableCellStyle}>
                      <h6>0</h6>
                    </td>
                  );
                })}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default TableDashboard;

export function TableDashboardAdv({ data }) {
  const tableCellStyle = {
    color: "black",
    border: "2px solid black ",
    padding: "3px",
  };

  const tableHeaderStyle = {
    border: "2px solid black !important",
    padding: "3px",
    background: "#f2f2f2",
  };

  return (
    <>
      <div className="" style={{ paddingBottom: "70px" }}>
        <table style={{ maxWidth: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {data?.headers.map((header, index) => (
                <th
                  className="customTh"
                  key={index}
                  style={{ border: "2px solid black", flex: "1" }}

                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.data.length > 0 ? (
              data?.data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <td
                      key={cellIndex}
                      style={{ flex: "1", ...tableCellStyle }}
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                {data?.headers.map((header, index) => (
                  <td key={index} style={{ flex: "1", ...tableCellStyle }}>
                    <h6>0</h6>
                  </td>
                ))}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export function TableNewDashboardAdv({ name, data1, data2, data3 }) {
  // const tableCellStyle = {
  //   color: "black",
  //   border: "2px solid black ",
  //   padding: "3px",
  // };

  // const tableHeaderStyle = {
  //   border: "2px solid black !important",
  //   padding: "3px",
  //   background: "#f2f2f2",
  // };

  return (
    <>
      <div className="col-md-4" style={{ paddingBottom: "70px" }}>
        <table style={{ maxWidth: "100%", borderCollapse: "collapse" }}>
          <tr>
            {data1?.headers.map((header, index) => { return index == 1 ? <td>{name} </td> : <></> }
            )}
          </tr>


          <thead>
            <tr style={{ height: '30px !important' }}>
              {data1?.headers.map((header, index) => (
                <th
                  className="customTh"
                  key={index}
                  style={{ background: '#143b64', color: '#FFFFFF', fontWeight: 'bold' }}

                >
                  {header}
                </th>
              ))}

              <th className="customTh"></th>


              {data2?.headers.map((header, index) => (
                <th
                  className="customTh"
                  key={index}
                  style={{ background: '#143b64', color: '#FFFFFF', fontWeight: 'bold' }}

                >
                  {header}
                </th>
              ))}
              <th className="customTh"></th>


              {data3?.headers.map((header, index) => (
                <th
                  className="customTh"
                  key={index}
                  style={{ background: '#143b64', color: '#FFFFFF', fontWeight: 'bold' }}

                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {console.log("data1,data2,data3", [
              ...(data1?.data ?? []),
              ...(data2?.data ?? []),
              ...(data3?.data ?? []),
            ])}
            {data1?.data.length + data2?.data.length + data3?.data.length >
              0 ? (
              data1?.data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <td
                      key={cellIndex}

                    >
                      {cell}
                    </td>
                  ))}

                  <th className="customTh"></th>



                  {data2?.data[rowIndex] &&
                    data2.data[rowIndex].map((cell, cellIndex) => (
                      <td
                        key={cellIndex}

                      >
                        {cell}
                      </td>
                    ))}

                  <th className="customTh"></th>



                  {data3?.data[rowIndex] &&
                    data3.data[rowIndex].map((cell, cellIndex) => (
                      <td
                        key={cellIndex}

                      >
                        {cell}
                      </td>
                    ))}
                </tr>

              ))


            ) : (
              <tr></tr>
            )}
          </tbody>
          <tr></tr>
          <tr></tr>
        </table>

      </div>
    </>
  );
}



export function TableNewDashboardAdvc({ name1, name2, name3, data1, data2, data3 }) {
  // const tableCellStyle = {
  //   color: "black",
  //   border: "2px solid black ",
  //   padding: "3px",
  // };

  // const tableHeaderStyle = {
  //   border: "2px solid black !important",
  //   padding: "3px",
  //   background: "#f2f2f2",
  // };

  return (
    <>
      <div className="col-md-4" style={{ paddingBottom: "70px" }}>
        <table style={{ maxWidth: "100%", borderCollapse: "collapse" }}>
          <tr>
            {data1?.headers.map((header, index) => { return index == 0 ? <td>{name1} </td> : <td></td> }
            )}
            <td>
            </td>

            {data2?.headers.map((header, index) => { return index == 0 ? <td>{name2} </td> : <td></td> }
            )}
            <td>

            </td>

            {data3?.headers.map((header, index) => { return index == 0 ? <td>{name3} </td> : <td></td> }
            )}
            <td>
            </td>
          </tr>



        </table>

      </div>
    </>
  );
}
